module.exports = __webpack_public_path__ + "static/character--pluggy-forward-arm-down@3x.2160bf23.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/character--pluggy-forward-arm-down@3x.png
// module id = 46
// module chunks = 168707334958949